<template>
  <AdminLayout v-model:activeTab="view">
    <div v-if="view === 'pedidos_laser'"><CrudPedidos /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import CrudPedidos from "@/components/TableroProduccion/SeguimientoLaser/CrudPedidosSeguimiento.vue";

const view = ref("pedidos_laser");
</script>
